var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockDark = function SvgLockDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14017_34013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30279 7.15177C5.48694 3.99188 8.07949 1.52457 11.2156 1.52457H12.7844C15.9205 1.52457 18.513 3.99188 18.6972 7.15177L18.9971 12.2984C19.0495 13.1973 18.37 13.9688 17.4794 14.0217C16.5888 14.0746 15.8244 13.3887 15.772 12.4898L15.472 7.34322C15.3883 5.90692 14.2099 4.78542 12.7844 4.78542H11.2156C9.79009 4.78542 8.61164 5.90692 8.52794 7.34322L8.22799 12.4898C8.17559 13.3887 7.41114 14.0746 6.52054 14.0217C5.62994 13.9688 4.95044 13.1973 5.00284 12.2984L5.30279 7.15177Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17565 21.1605C2.2953 22.4051 3.29882 23.2948 4.54749 23.3601C6.0874 23.4406 8.52665 23.5246 12 23.5246C15.4734 23.5246 17.9126 23.4406 19.4525 23.3601C20.7012 23.2948 21.7047 22.4051 21.8244 21.1605C21.9193 20.1727 22 18.8085 22 17.0246C22 15.2407 21.9193 13.8765 21.8244 12.8887C21.7047 11.644 20.7012 10.7543 19.4525 10.6891C17.9126 10.6086 15.4734 10.5246 12 10.5246C8.52665 10.5246 6.0874 10.6086 4.54749 10.6891C3.29882 10.7543 2.2953 11.644 2.17565 12.8887C2.0807 13.8765 2 15.2407 2 17.0246C2 18.8085 2.0807 20.1727 2.17565 21.1605Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9066 17.3078C13.5555 16.9772 14 16.3028 14 15.5246C14 14.42 13.1045 13.5246 12 13.5246C10.8954 13.5246 10 14.42 10 15.5246C10 16.3028 10.4445 16.9772 11.0934 17.3078L10.6498 19.5256C10.5614 19.9678 10.7896 20.4038 11.2355 20.4707C11.4454 20.5021 11.7003 20.5246 12 20.5246C12.2998 20.5246 12.5546 20.5021 12.7645 20.4707C13.2104 20.4038 13.4386 19.9678 13.3502 19.5256L12.9066 17.3078Z",
    fill: "#0F172A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14017_34013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
};
export default SvgLockDark;